import icon70100004 from '@/assets/imgs/act/ann2026/items/70100004.png'
import icon80102101 from '@/assets/imgs/act/ann2026/items/80102101.png'
import icon70100011 from '@/assets/imgs/act/ann2026/items/70100011.png'
import icon70100014 from '@/assets/imgs/act/ann2026/items/70100014.png'
import icon70100013 from '@/assets/imgs/act/ann2026/items/70100013.png'
import icon10101404 from '@/assets/imgs/act/ann2026/items/10101404.png'
import icon50111700 from '@/assets/imgs/act/ann2026/items/50111700.png'
import icon80103001 from '@/assets/imgs/act/ann2026/items/80103001.png'
import icon1010102006 from '@/assets/imgs/act/ann2026/items/1010102006.png'
import icon32701006 from '@/assets/imgs/act/ann2026/items/32701006.png'
import icon81010999 from '@/assets/imgs/act/ann2026/items/81010999.png'
import icon90301910 from '@/assets/imgs/act/ann2026/items/90301910.png'
import icon90301911 from '@/assets/imgs/act/ann2026/items/90301911.png'
import icon90501244 from '@/assets/imgs/act/ann2026/items/90501244.png'
import icon90501245 from '@/assets/imgs/act/ann2026/items/90501245.png'

// 透明占位图：未知数字 ID 不产生裂图，字母来源 code 由调用方选择不渲染图标。
export const placeholderIcon =
  'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='

export const itemIcons = {
  70100004: icon70100004,
  80102101: icon80102101,
  70100011: icon70100011,
  70100014: icon70100014,
  70100013: icon70100013,
  10101404: icon10101404,
  50111700: icon50111700,
  80103001: icon80103001,
  1010102006: icon1010102006,
  32701006: icon32701006,
  81010999: icon81010999,
  90301910: icon90301910,
  90301911: icon90301911,
  90501244: icon90501244,
  90501245: icon90501245,
}

export const isItemId = (id) => /^\d+$/.test(String(id ?? ''))

export const getItemIcon = (id) => itemIcons[String(id)] || placeholderIcon
